require('./cookie-access.less');

const container = document.querySelector('.cookie-access');
if (document.cookie.indexOf("cookie-access") != -1) {
    container.classList.remove('cookie-access--active');
}else{
    container.classList.add('cookie-access--active');
}
if (container) {
    const apply = container.querySelector('.js-agree');
    apply.addEventListener('click', () => {
        console.log(apply);
        container.classList.remove('cookie-access--active');
        document.cookie = 'cookie-access=true; max-age=2592000; path=/';
    });
}

jQuery(function() {
    $('.js-more-cookie-text').on('click', function(e) {
        e.preventDefault();
        $('.cookie-access__full-text').fadeToggle();
    });
    $('.js-cancel').on('click', function(e) {
        e.preventDefault();
        $('.cookie-access').removeClass('cookie-access--active');
    });
});



// WEBPACK FOOTER //
// ./modules/cookie-access/cookie-access.js